// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__IYKkh","content":"LayoutSettings_content__3TZq8"};